import {
  Megaphone, Server, Code, Scale, Calculator, Users, Factory, Truck,
  Building2, HardHat, Wrench, Stethoscope, Shield, Landmark, Video,
  Palette, ShieldCheck, GraduationCap, Settings
} from "lucide-react";

export const CATEGORY_META = {
  "marketing-advertising":  { Icon: Megaphone,     accent: "#FF6B3D" },
  "it-services":            { Icon: Server,        accent: "#0055FF" },
  "software-saas":          { Icon: Code,          accent: "#7C3AED" },
  "legal-services":         { Icon: Scale,         accent: "#0F172A" },
  "accounting-finance":     { Icon: Calculator,    accent: "#0EA5E9" },
  "hr-recruiting":          { Icon: Users,         accent: "#10B981" },
  "manufacturing":          { Icon: Factory,       accent: "#525252" },
  "logistics-supply":       { Icon: Truck,         accent: "#F59E0B" },
  "commercial-real-estate": { Icon: Building2,     accent: "#0F766E" },
  "construction-trades":    { Icon: HardHat,       accent: "#EA580C" },
  "engineering":            { Icon: Wrench,        accent: "#4338CA" },
  "healthcare-services":    { Icon: Stethoscope,   accent: "#DC2626" },
  "insurance-risk":         { Icon: Shield,        accent: "#1D4ED8" },
  "banking-capital":        { Icon: Landmark,      accent: "#065F46" },
  "media-production":       { Icon: Video,         accent: "#DB2777" },
  "design-creative":        { Icon: Palette,       accent: "#9333EA" },
  "cybersecurity":          { Icon: ShieldCheck,   accent: "#0F172A" },
  "education-training":     { Icon: GraduationCap, accent: "#2563EB" },
  "facilities-maintenance": { Icon: Settings,      accent: "#6B7280" },
};
